
import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden flex items-center justify-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1594223274512-ad4803739b7c?auto=format&fit=crop&q=80&w=1920"
          alt="Luxury Handbag Lifestyle"
          className="w-full h-full object-cover scale-105 animate-[slowZoom_20s_ease-in-out_infinite]"
        />
        <div className="absolute inset-0 bg-brand-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6">
        <span className="text-white text-[12px] uppercase tracking-[0.4em] mb-6 block opacity-0 animate-[fadeInUp_1s_ease-out_forwards]">
          Depuis 2025
        </span>
        <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-10 opacity-0 animate-[fadeInUp_1s_ease-out_0.3s_forwards]">
          Le Chic <br />
          <span className="italic"> à Prix Accessible</span>
        </h2>
        <div className="opacity-0 animate-[fadeInUp_1s_ease-out_0.6s_forwards]">
          <Link 
            to="/shop"
            className="inline-block border border-white px-10 py-4 text-white text-[11px] uppercase tracking-[0.3em] font-medium hover:bg-white hover:text-brand-black transition-all duration-500"
          >
            Découvrir la collection
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
